import { Component, OnInit, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import {Router} from '@angular/router';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';

const constraints = {
  audio: false,
  video: {
    facingMode: 'user'
  }
}


declare const $: any;

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.scss']
})
export class CameraComponent implements OnInit, AfterViewInit {


  @Input() fileName: string = '';
  @Input() numberPhoto: number = 1;
  @Input() saveStatus: string = null;

  @Output() sendImage:EventEmitter<any> = new EventEmitter<any>();
  @Output() closeCamera:EventEmitter<any> = new EventEmitter<any>();

  public showPhoto: boolean;
  public theStream: MediaStream;

  public webcamImage: WebcamImage = null;
  private trigger: Subject<void> = new Subject<void>();
  triggerSnapshot(): void {
   this.trigger.next();
  }

  async handleImage(webcamImage: WebcamImage): Promise<void> {
   // console.info('Saved webcam image', webcamImage);
     this.webcamImage = webcamImage;
     let blob = await this.b64toBlob(webcamImage.imageAsDataUrl);
     var file = new File([blob], this.fileName);
     let image = {
        base64: webcamImage.imageAsDataUrl,
        file,
        numero: this.numberPhoto 
      }
    this.sendImage.next(image);
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
   }

  constructor(private router: Router) {
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.getStream();
  }

  goBack() {

      this.takePhoto().then(() => {

      });

  }

  goto(id: string) {

  } 


  getStream() {
    let video:any = '';
    let video_interval = setInterval(() => {
       video = document.getElementById('player');
       if (video != null ){
          clearInterval(video_interval);
          setTimeout(() => {
            navigator.mediaDevices.getUserMedia(constraints)
            .then((localMediaStream:any) => {
              // console.log(localMediaStream);
              this.theStream = localMediaStream;
              if ('srcObject' in video) {
                video.srcObject = localMediaStream;
              } else {
                video.src = URL.createObjectURL(localMediaStream);
              }
              // video.src = window.URL.createObjectURL(localMediaStream);
              video.play();
            })
            .catch(err => {
              console.error(`OH NO!!!!`, err);
            });
          }, 500)
       }
      
    },1000)
    
    
    
    
  }

  public handleInitError(error: WebcamInitError): void {
    if (error.mediaStreamError && error.mediaStreamError.name === "NotAllowedError") {
      console.warn("Camera access was not allowed by user!");
    }
  }

  takePhoto(): Promise<any> {
    return new Promise((resolve, reject) => {
      // this.showPhoto = true;
      if (!('ImageCapture' in window)) {
        alert('ImageCapture is not available');
        return;
      }

      if (!this.theStream) {
        alert('Grab the video stream first!');
        return;
      }

      const theImageCapturer = new (window as any).ImageCapture(this.theStream.getVideoTracks()[0]);

      theImageCapturer.takePhoto()
        .then(blob => {

          const reader = new FileReader();
          var file = new File([blob], this.fileName);
          
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            this.saveStatus = null;
            let image = {
              base64: reader.result,
              file,
              numero: this.numberPhoto 
            }
            this.sendImage.next(image);

          };
        })
        .catch(err => alert('Error: ' + err));
    });
  }

  closeDialog(){
    this.closeCamera.next(false);
  }

  async b64toBlob(b64Data, contentType='image/jpeg')  {
    contentType = 'image/png';
    // application/octet-stream
    const url = `data:${contentType};${b64Data}`;
    const response = await fetch(b64Data);
    const blob = await response.blob();
    return blob;
  };


}






